module.exports = __webpack_public_path__ + "img/412.0c4fe49b.png";